import { RouteEnums } from '@Helper/Enums';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankTwoToneIcon from '@mui/icons-material/CheckBoxOutlineBlankTwoTone';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import TransformIcon from '@mui/icons-material/Transform';
import {
  Button,
  Checkbox,
  Grid,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import moment from 'moment';
import { NestedMenuItem } from 'mui-nested-menu';
import React, { FC, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Icons } from '../../../assets/SvgIcons';
import { PageType, TaskViewType } from '../../../config/enum';
import { Section } from '../../../config/section';
import { TaskType } from '../../../config/task';
import { ComponentHelper } from '../../../helper/Infra';
import { ICTask, ISUpdateCoreRisk } from '../../../helper/Interfaces';
import { getAssetsFunctionalAreas } from '../../../store/feature/assetsSlice';
import { getPlayBookDetail } from '../../../store/feature/playBookDetailSlice';
import {
  deleteTaskHistory,
  selectedTaskDetailUpdate,
} from '../../../store/feature/taskSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { DotDateCard } from '../DotDateCard/DotDateCard';
import EditTextField from '../EditTextField/EditTextField';
import IconSelectTool from '../IconSelectTool/IconSelectTool';
import NewTask from '../NewTask/NewTask';
import { UserAvatarCard } from '../UserAvatarCard/UserAvatarCard';
import { Undo } from './components/DeleteDialog';
import classes from './TodoCard.module.css';

type TodoCardProps = {
  task: ICTask;
  isFromList?: boolean;
  children?: any;
  subTaskCount: number;
  subRiskCount?: number;
  subIssueCount?: number;
  subDecisionCount?: number;
  subDependencyCount?: number;
  taskViewType: TaskViewType;
  deleteTask?: (task: ICTask, stopDelete?: string) => void;
  updateTask?: (currentTask: ICTask, username: string) => void;
  updateTaskDate?: (currentTask: ICTask, taskDate: string) => void;
  updateTaskName?: (currentTask: ICTask, taskName: string) => void;
  updateTaskSection?: (currentTask: ICTask, sectionId: string) => void;
  updateTaskProperty?: (taskId: string, property: string, value: any) => any;
  startDate: string | null | undefined;
  hideMoreIcon?: boolean;
  pageType?: PageType;
  handleClickTask?: (task: ICTask) => void;
  shadowTitle?: string;
  setopenParentModal?: (click: boolean) => void;
  selectedSubTask?: (task: ICTask) => void;
  isTypeVisible?: boolean;
  dependency?: React.ReactNode;
  disabled?: boolean;
};

const TodoCard: FC<TodoCardProps> = ({
  task,
  isFromList,
  children,
  subTaskCount,
  subIssueCount,
  subRiskCount,
  taskViewType,
  deleteTask,
  startDate,
  updateTask,
  updateTaskDate,
  updateTaskSection,
  updateTaskName,
  updateTaskProperty,
  subDecisionCount,
  subDependencyCount,
  hideMoreIcon,
  pageType,
  handleClickTask,
  shadowTitle,
  setopenParentModal,
  selectedSubTask,
  isTypeVisible,
  dependency,
  disabled,
}) => {
  const location = useLocation();

  let template = false;
  if (location.pathname.split('/')[1] === 'personal-templates-detail') {
    template = true;
  }

  const dispatch = useAppDispatch();

  const [title, setTitle] = useState<string>(task.name ?? '');

  const { dealTaskList, sectionList } = useAppSelector(getPlayBookDetail);

  const [taskDate, setTaskDate] = useState<Date | undefined>(undefined);
  const [isDone, setIsDone] = useState(task.isCompleted);
  const [newTaskVisible, setnewTaskVisible] = useState<boolean>(false);
  const [nameEdit, setNameEdit] = useState<boolean>(false);
  const { id, pid, tabNumber } = useParams();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const openMoreMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const closeMoreMenu = () => {
    setAnchorEl(null);
  };
  function reducer(state: any, action: any) {
    switch (action.type) {
      case 'init':
        if (deleteTask) deleteTask(task, 'init');
        return {
          collection: state,
          toRemove: [...state.toRemove, action.id],
        };
      case 'normal':
        if (deleteTask) deleteTask(task, 'normal');
        console.log('normal');
        return {
          collection: state,
          toRemove: [],
        };
      case 'break':
        if (deleteTask) deleteTask(task, 'break');
        console.log('break');
        return {
          collection: state,
          toRemove: [],
        };
      default:
        return state;
    }
  }

  const [, deleteDispatch] = React.useReducer(reducer, {
    collection: task,
    toRemove: [],
  });

  const nestedOpen = Boolean(anchorEl);

  const funcitonalAreas = useAppSelector(getAssetsFunctionalAreas);
  const [sectionStateList, setsectionStateList] = useState<Section[]>([]);
  const componentHelper = new ComponentHelper();
  const currentDay =
    new Date().getFullYear() +
    '-' +
    (new Date().getMonth() + 1) +
    '-' +
    ('0' + new Date().getDate()).slice(-2);

  useEffect(() => {
    setTitle(task.name ?? '');
    setTaskDate(
      task.dueDate ? moment(task.dueDate.split('T')[0]).toDate() : undefined
    );
    setIsDone(task.isCompleted);
  }, [task]);

  const updateTaskCopy = () => {};

  const getTaskColor = () => {
    const yellow = '#FFAB00';
    const red = '#FF5630';
    const green = '#36B37E';
    if (!task.dueDate) {
      return yellow;
    } else if (task.isCompleted === true) {
      return green;
    } else {
      if (
        moment(currentDay).diff(moment(task.dueDate.split('T')[0]), 'days') > 0
      ) {
        return red;
      } else {
        if (
          dealTaskList &&
          dealTaskList.filter(
            i =>
              (i.type === 'risk' || i.type === 'issue') &&
              i.isCompleted !== true &&
              i.parentId === task.id
          ).length
        ) {
          return yellow;
        } else {
          return green;
        }
      }
    }
  };

  const getRaidTaskColor = (pageType: PageType) => {
    const yellow = '#FFAB00';
    const red = '#FF5630';
    const green = '#36B37E';
    const gray = '#a7a5ba';
    if (pageType === PageType.RISKS) {
      return turnColor(task.riskLikelihood ?? '');
    } else if (pageType === PageType.ISSUES) {
      return turnColor(task.issueImpact ?? '');
    } else if (pageType === PageType.DECISIONS) {
      return turnColor(task.priority ?? '');
    }

    function turnColor(type: string) {
      switch (type) {
        case 'high':
          return red;
        case 'medium':
          return yellow;
        case 'low':
          return green;

        default:
          return gray;
      }
    }
  };

  const handleTaskClick = () => {
    const data = {
      selectedTask: task,
      isShowTaskModal: true,
    };
    dispatch(selectedTaskDetailUpdate(data));
  };

  useEffect(() => {
    if (sectionList && sectionList.length > 0) {
      const newElem = JSON.parse(JSON.stringify(sectionList)) as Section[];
      const sortedOnes = newElem.sort(function (a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      });
      setsectionStateList(sortedOnes);
    }
  }, [sectionList]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (updateTaskProperty && task.id) {
      if (task.type === 'decision') {
        toast('Please enter the final decision before closing');
        return;
      }
      const checkStatus = event.target.checked;
      updateTaskProperty(task.id, 'isCompleted', event.target.checked)
        .then(() => {
          setIsDone(checkStatus);
        })
        .catch((data: any) => {
          toast(data?.message ?? 'Unknown error');
        });
    }
  };

  const updateTaskWidth = (value: string) => {
    if (value && value?.length > 50) {
      return 'task-text-content';
    }
    return '';
  };

  return (
    <>
      <div
        className={[
          classes.TodoCard,
          taskViewType === TaskViewType.BOARD ? classes.TodoCardBoard : '',
          isFromList ? classes.bgColorFf : '',
        ].join(' ')}
        style={{ flex: pageType === PageType.ARCHIVE ? '1' : '0' }}
        onClick={event => {
          if (handleClickTask) {
            handleClickTask(task);
          } else {
            const clickedPlace = Object.entries(
              (event.target as any).classList
            ).join(' ');
            //console.log('clickedPlace', clickedPlace);

            if (
              clickedPlace.length === 0 ||
              clickedPlace.includes('input') ||
              clickedPlace.includes('MuiBackdrop') ||
              clickedPlace.includes('MuiMenuItem') ||
              clickedPlace.includes('MuiCheckbox') ||
              clickedPlace.includes('PrivateSwitchBase') ||
              clickedPlace.includes('taskTextContent') ||
              clickedPlace.includes('MuiSvgIcon-root') ||
              clickedPlace.includes('MuiButton') ||
              clickedPlace.includes('MuiAvatar-root') ||
              clickedPlace.includes('MuiCalendarPicker') ||
              clickedPlace.includes('MuiAutocomplete-option') ||
              clickedPlace.includes('css-1dozdou') ||
              clickedPlace.includes('css-l0iinn') ||
              clickedPlace.includes('PrivatePickersSlideTransition-root') ||
              clickedPlace.includes('css-1v994a0') ||
              clickedPlace.includes('css-epd502') ||
              clickedPlace.includes('css-k008qs') ||
              clickedPlace.includes('css-j7qwjs') ||
              clickedPlace.includes('MuiTypography-root') ||
              clickedPlace.includes('PrivatePickersYear-yearButton') ||
              clickedPlace.includes('EditTextField')
            ) {
              console.log('');
            } else {
              handleTaskClick();
            }
          }
        }}
      >
        <div
          className={[
            classes.TodoCardItem,
            taskViewType === TaskViewType.BOARD && classes.TodoCardItemBoard,
          ].join(' ')}
        >
          <Grid
            container
            spacing={1}
            alignItems={
              taskViewType === TaskViewType.BOARD ? 'flex-start' : 'center'
            }
          >
            <Grid
              item
              xs={12}
              md={12}
              lg={taskViewType === TaskViewType.BOARD ? 12 : 6}
            >
              <div
                className={[
                  classes.TodoCardItemLeft,
                  taskViewType === TaskViewType.BOARD
                    ? classes.TodoCardItemLeftBoard
                    : '',
                  isDone && 'task-done',
                  updateTaskWidth(task.name || ''),
                ].join(' ')}
              >
                <div className={classes.taskTextContent}>
                  {!template &&
                    pageType !== PageType.ARCHIVE &&
                    pageType !== PageType.NOTIFICATIONS && (
                      <Checkbox
                        color="default"
                        checked={isDone}
                        onChange={handleCheckboxChange}
                        disabled={disabled}
                        icon={
                          task.type === 'milestone' ? (
                            <Icons.Diamond />
                          ) : (
                            <CheckBoxOutlineBlankTwoToneIcon />
                          )
                        }
                        checkedIcon={
                          task.type === 'milestone' ? (
                            <Icons.DiamondChecked />
                          ) : (
                            <CheckBoxIcon />
                          )
                        }
                      />
                    )}
                  {isTypeVisible && (
                    <>
                      {task.type === 'risk' ? (
                        <span className="ridType-text">[RISK]</span>
                      ) : task.type === 'issue' ? (
                        <span className="ridType-text">[ISSU]</span>
                      ) : task.type === 'decision' ? (
                        <span className="ridType-text">[DEC]</span>
                      ) : null}
                    </>
                  )}

                  <EditTextField
                    style={{
                      minWidth:
                        taskViewType === TaskViewType.BOARD ? 230 : 'auto',
                      fontWeight: task.type === 'milestone' ? 'bold' : 'normal',
                    }}
                    handleClick={updateTaskCopy}
                    value={shadowTitle ?? title}
                    setValue={setTitle}
                    isActive={nameEdit}
                    updateTaskName={updateTaskName}
                    task={task}
                    setIsActive={setNameEdit}
                    dotView={taskViewType === TaskViewType.BOARD}
                  />
                  {taskViewType === TaskViewType.LIST ? (
                    <div></div>
                  ) : (
                    <Grid item>
                      {!hideMoreIcon && (
                        <IconButton
                          aria-label="delete"
                          size="small"
                          //onClick={() => setnewTaskVisible(true)}
                          onClick={openMoreMenu}
                          disabled={disabled}
                        >
                          <MoreHorizIcon />
                        </IconButton>
                      )}

                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={closeMoreMenu}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                        }}
                        PaperProps={{
                          style: {
                            background: '#ffffff',
                            border: ' 1px solid #ebebf0',
                            boxSizing: 'border-box',
                            boxShadow: ' 0px 8px 16px rgba(0, 0, 0, 0.1)',
                            borderRadius: 4,
                            padding: '8px 8px 6px',
                            width: 208,
                          },
                        }}
                      >
                        {!template && (
                          <div className={classes.moreMenuCopy}>
                            <Button
                              variant="outlined"
                              onClick={() => {
                                componentHelper.unsecuredCopyToClipboard(
                                  window.location.origin +
                                    RouteEnums.Playbook +
                                    id +
                                    '/' +
                                    pid +
                                    '/' +
                                    tabNumber +
                                    '?selectedIssue=' +
                                    task?.itemNumber
                                );
                                closeMoreMenu();
                              }}
                            >
                              Copy Link
                            </Button>
                            <Button
                              variant="outlined"
                              onClick={() => {
                                componentHelper.unsecuredCopyToClipboard(
                                  task.id || ''
                                );
                                closeMoreMenu();
                              }}
                            >
                              Copy ID
                            </Button>
                          </div>
                        )}

                        <MenuItem
                          className={classes.moreMenuItem}
                          onClick={() => {
                            setNameEdit(true);
                            closeMoreMenu();
                          }}
                          disabled={disabled}
                        >
                          <Icons.Rename /> <span>Rename</span>
                        </MenuItem>
                        <MenuItem
                          className={classes.moreMenuItem}
                          onClick={closeMoreMenu}
                          disabled={disabled}
                        >
                          <Icons.Duplicate /> <span>Duplicate</span>
                        </MenuItem>

                        {task.parentId === null ? (
                          <div>
                            <NestedMenuItem
                              parentMenuOpen={nestedOpen}
                              label="Change Section"
                              disabled={disabled}
                            >
                              {sectionStateList
                                .filter(i => i.id !== task.id)
                                .map(section => {
                                  return (
                                    <MenuItem
                                      sx={{ pl: 4 }}
                                      className={classes.moreMenuItem}
                                      onClick={() => {
                                        if (updateTaskSection)
                                          updateTaskSection(task, section.id);
                                        closeMoreMenu();
                                      }}
                                      key={section.id}
                                    >
                                      <span>{section.name}</span>
                                    </MenuItem>
                                  );
                                })}
                            </NestedMenuItem>
                          </div>
                        ) : (
                          <div></div>
                        )}

                        {deleteTask && (
                          <MenuItem
                            className={classes.moreMenuItem}
                            disabled={disabled}
                            onClick={() => {
                              closeMoreMenu();
                              deleteDispatch({ task, type: 'init' });
                              toast(
                                <Undo
                                  onUndo={() => {
                                    deleteDispatch({ task, type: 'break' });
                                  }}
                                  message="Successfully deleted"
                                  taskName={task.name ?? ''}
                                />,
                                {
                                  onClose: () => {
                                    deleteDispatch({ task, type: 'normal' });
                                  },
                                }
                              );
                            }}
                          >
                            <Icons.Delete2 color="#FF5630" />
                            <span style={{ color: '#FF5630' }}>Delete</span>
                          </MenuItem>
                        )}
                      </Menu>
                    </Grid>
                  )}
                </div>
                <div className={classes.taskIconContent}>
                  {subTaskCount > 0 && (
                    <div className={classes.taskIconItem}>
                      <Icons.SubTaskIcon color="#7D7A9A" /> {subTaskCount}
                    </div>
                  )}
                  {subIssueCount && subIssueCount > 0 ? (
                    <div className={classes.taskIconItem}>
                      <Icons.Issues20 /> {subIssueCount}
                    </div>
                  ) : (
                    <div></div>
                  )}
                  {subRiskCount && subRiskCount > 0 ? (
                    <div className={classes.taskIconItem}>
                      <Icons.Risks20 /> {subRiskCount}
                    </div>
                  ) : (
                    <div></div>
                  )}
                  {subDecisionCount && subDecisionCount > 0 ? (
                    <div className={classes.taskIconItem}>
                      <Icons.Decision20 /> {subDecisionCount}
                    </div>
                  ) : (
                    <div></div>
                  )}
                  {subDependencyCount && subDependencyCount > 0 ? (
                    <div className={classes.taskIconItem}>
                      <Icons.Dependency color="#6E6B8C" /> {subDependencyCount}
                    </div>
                  ) : (
                    <div></div>
                  )}
                  {task.hasDescription ? (
                    <div className={classes.taskIconItem}>
                      <Icons.Description />
                    </div>
                  ) : (
                    <div></div>
                  )}
                  {task.commentCount && task.commentCount !== '0' ? (
                    <div className={classes.taskIconItem}>
                      <Icons.Comment />
                    </div>
                  ) : (
                    <div></div>
                  )}
                  {task.attachmentCount && task.attachmentCount !== '0' ? (
                    <div className={classes.taskIconItem}>
                      <Icons.Attachment />
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              lg={taskViewType === TaskViewType.BOARD ? 12 : 6}
              // style={{
              //   paddingTop: taskViewType === TaskViewType.BOARD ? 0 : 0,
              // }}
            >
              <Grid
                container
                justifyContent={
                  taskViewType === TaskViewType.BOARD
                    ? 'flex-start'
                    : 'flex-end'
                }
                alignItems={'center'}
              >
                {taskViewType === TaskViewType.BOARD ||
                pageType === PageType.NOTIFICATIONS ? (
                  <div></div>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {pageType &&
                      (pageType === PageType.RISKS ||
                        pageType === PageType.ISSUES ||
                        pageType === PageType.DECISIONS) && (
                        <>
                          <Grid item>
                            <div
                              style={{
                                width: 'auto',
                                fontFamily: 'Inter',
                                color: '#3F4575',
                                fontSize: 13,
                                backgroundColor: '#6ababf',
                                display: 'flex',
                                justifyContent: 'center',
                                borderRadius: 100,
                                alignItems: 'center',
                                padding: '3px 7px',
                              }}
                            >
                              {
                                funcitonalAreas?.find(
                                  i => i.id === task.playbookFunction
                                )?.shortName
                              }{' '}
                              Workstream
                            </div>
                          </Grid>
                          {pageType === PageType.RISKS && (
                            <Grid
                              item
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              <IconSelectTool
                                fourIcon={[
                                  {
                                    value: 'High',
                                    elem: <Icons.Box color="#FF5630" />,
                                  },
                                  {
                                    value: 'Medium',
                                    elem: <Icons.Box color="#FFAB00" />,
                                  },
                                  {
                                    value: 'Low',
                                    elem: <Icons.Box color="#36B37E" />,
                                  },
                                  {
                                    value: 'None',
                                    elem: <Icons.Box color="#a7a5ba" />,
                                  },
                                ]}
                                onChange={(value: string) => {
                                  //console.log('updateTaskProperty', value);
                                  const newTaskRisk =
                                    {} as unknown as ISUpdateCoreRisk;
                                  (newTaskRisk as any)['likelihood'] =
                                    value.toLowerCase();

                                  componentHelper.updateRisk(
                                    task.id ?? '',
                                    newTaskRisk
                                  );
                                }}
                                currentOption={task.riskLikelihood ?? ''}
                                options={['High', 'Medium', 'Low', 'None']}
                                icon={
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <Icons.Box
                                      color={getRaidTaskColor(PageType.RISKS)}
                                    />
                                  </div>
                                }
                              />
                            </Grid>
                          )}
                          {pageType === PageType.ISSUES && (
                            <Grid item>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              >
                                <IconSelectTool
                                  fourIcon={[
                                    {
                                      value: 'High',
                                      elem: <Icons.Hammer color="#FF5630" />,
                                    },
                                    {
                                      value: 'Medium',
                                      elem: <Icons.Hammer color="#FFAB00" />,
                                    },
                                    {
                                      value: 'Low',
                                      elem: <Icons.Hammer color="#36B37E" />,
                                    },
                                    {
                                      value: 'None',
                                      elem: <Icons.Hammer color="#a7a5ba" />,
                                    },
                                  ]}
                                  onChange={(value: string) => {
                                    // console.log('updateTaskProperty', value);
                                    const newTaskRisk =
                                      {} as unknown as ISUpdateCoreRisk;
                                    (newTaskRisk as any)['issueImpact'] =
                                      value.toLowerCase();

                                    componentHelper.updateIssue(
                                      task.id ?? '',
                                      newTaskRisk
                                    );
                                  }}
                                  currentOption={task.issueImpact ?? ''}
                                  options={['High', 'Medium', 'Low', 'None']}
                                  icon={
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <Icons.Hammer
                                        color={getRaidTaskColor(PageType.RISKS)}
                                      />
                                    </div>
                                  }
                                />
                              </div>
                            </Grid>
                          )}
                          {pageType === PageType.DECISIONS && (
                            <Grid item>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              >
                                <IconSelectTool
                                  fourIcon={[
                                    {
                                      value: 'High',
                                      elem: <Icons.Decision color="#FF5630" />,
                                    },
                                    {
                                      value: 'Medium',
                                      elem: <Icons.Decision color="#FFAB00" />,
                                    },
                                    {
                                      value: 'Low',
                                      elem: <Icons.Decision color="#36B37E" />,
                                    },
                                    {
                                      value: 'None',
                                      elem: <Icons.Decision color="#a7a5ba" />,
                                    },
                                  ]}
                                  onChange={(value: string) => {
                                    //console.log('updateTaskProperty', value);
                                    const newTaskRisk = {} as any;
                                    (newTaskRisk as any)['priority'] =
                                      value.toLowerCase();

                                    componentHelper.updateTask({
                                      id: task.id,
                                      priority: value.toLowerCase(),
                                    } as any);
                                  }}
                                  currentOption={task.priority ?? ''}
                                  options={['High', 'Medium', 'Low', 'None']}
                                  icon={
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <Icons.Decision
                                        color={getRaidTaskColor(
                                          PageType.DECISIONS
                                        )}
                                      />
                                    </div>
                                  }
                                />
                              </div>
                            </Grid>
                          )}
                        </>
                      )}
                    {pageType &&
                      pageType === PageType.DEPENDENCIES &&
                      dependency &&
                      dependency}
                    <Grid item>
                      {template ? (
                        <></>
                      ) : (
                        <DotDateCard
                          isEditable={true}
                          color={getTaskColor()}
                          value={taskDate}
                          setValue={setTaskDate}
                          handleClick={updateTaskCopy}
                          updateTaskDate={updateTaskDate}
                          task={task}
                          disabled={disabled}
                        />
                      )}
                    </Grid>
                    {taskDate !== undefined && (
                      <>
                        <Grid item>
                          <div
                            style={{
                              color: getTaskColor(),
                              width: 'auto',
                              fontSize: 15,
                              fontFamily: 'Inter',
                              marginRight: 20,
                              minWidth: 100,
                              marginLeft: 20,
                            }}
                          >
                            {task.dueDate && !task.isCompleted ? (
                              <span>
                                {moment(currentDay).diff(
                                  moment(task.dueDate.split('T')[0]),
                                  'days'
                                ) === 0
                                  ? 'Due today'
                                  : new Date() < new Date(task.dueDate)
                                  ? moment(task.dueDate.split('T')[0]).diff(
                                      moment(currentDay),
                                      'days'
                                    ) + ' days to go'
                                  : moment(currentDay).diff(
                                      moment(task.dueDate.split('T')[0]),
                                      'days'
                                    ) + ' days overdue'}
                              </span>
                            ) : (
                              <div></div>
                            )}
                            <span></span>
                          </div>
                        </Grid>
                      </>
                    )}
                  </div>
                )}

                {pageType === PageType.NOTIFICATIONS || template ? (
                  <div></div>
                ) : (
                  <Grid item>
                    <div
                      style={{ width: 40, textAlign: 'center', marginLeft: 10 }}
                    >
                      <UserAvatarCard
                        task={task}
                        updateTask={updateTask}
                        disabled={disabled}
                      />
                    </div>
                  </Grid>
                )}

                {taskViewType === TaskViewType.LIST ? (
                  <div></div>
                ) : (
                  <>
                    {pageType && pageType === PageType.RISKS && (
                      <>
                        <Grid item>
                          <div>
                            <Icons.Box
                              color={getRaidTaskColor(PageType.RISKS)}
                            />
                          </div>
                        </Grid>
                      </>
                    )}
                    {pageType && pageType === PageType.ISSUES && (
                      <>
                        <Grid item>
                          <div>
                            <Icons.Hammer
                              color={getRaidTaskColor(PageType.ISSUES)}
                            />
                          </div>
                        </Grid>
                      </>
                    )}
                    {pageType && pageType === PageType.DECISIONS && (
                      <>
                        <Grid item>
                          <div>
                            <Icons.Decision
                              color={getRaidTaskColor(PageType.DECISIONS)}
                            />
                          </div>
                        </Grid>
                      </>
                    )}
                    <Grid item style={{ marginLeft: 10 }}>
                      <DotDateCard
                        isEditable={true}
                        color={getTaskColor()}
                        value={taskDate}
                        setValue={setTaskDate}
                        handleClick={updateTaskCopy}
                        updateTaskDate={updateTaskDate}
                        task={task}
                      />
                    </Grid>
                    <Grid item>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          color: getTaskColor(),
                          width: 140,
                          fontSize: 15,
                          fontFamily: 'Inter',
                          marginRight: 35,
                        }}
                      >
                        {task.dueDate ? (
                          <span>
                            {moment(currentDay).diff(
                              moment(task.dueDate.split('T')[0]),
                              'days'
                            ) === 0
                              ? 'Due today'
                              : new Date() < new Date(task.dueDate)
                              ? moment(task.dueDate.split('T')[0]).diff(
                                  moment(currentDay),
                                  'days'
                                ) + ' days to go'
                              : moment(currentDay).diff(
                                  moment(task.dueDate.split('T')[0]),
                                  'days'
                                ) + ' days overdue'}
                          </span>
                        ) : (
                          <div></div>
                        )}
                        <span></span>
                      </div>
                    </Grid>
                  </>
                )}

                {isFromList ? <div></div> : <div></div>}
                {taskViewType === TaskViewType.BOARD ? (
                  <div></div>
                ) : (
                  <Grid item>
                    {!hideMoreIcon && (
                      <IconButton
                        aria-label="delete"
                        size="small"
                        onClick={openMoreMenu}
                        style={{ marginLeft: 20 }}
                      >
                        <MoreHorizIcon />
                      </IconButton>
                    )}
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={closeMoreMenu}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                      PaperProps={{
                        style: {
                          background: '#ffffff',
                          border: ' 1px solid #ebebf0',
                          boxSizing: 'border-box',
                          boxShadow: ' 0px 8px 16px rgba(0, 0, 0, 0.1)',
                          borderRadius: 4,
                          padding: '8px 8px 6px',
                          width: 208,
                        },
                      }}
                    >
                      {!template && (
                        <div className={classes.moreMenuCopy}>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              componentHelper.unsecuredCopyToClipboard(
                                window.location.origin +
                                  RouteEnums.Playbook +
                                  id +
                                  '/' +
                                  pid +
                                  '/' +
                                  tabNumber +
                                  '?selectedIssue=' +
                                  task?.itemNumber
                              );
                              closeMoreMenu();
                            }}
                          >
                            Copy Link
                          </Button>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              componentHelper.unsecuredCopyToClipboard(
                                task.id || ''
                              );
                              closeMoreMenu();
                            }}
                          >
                            Copy ID
                          </Button>
                        </div>
                      )}

                      {pageType && pageType === PageType.ARCHIVE ? null : (
                        <div>
                          <MenuItem
                            className={classes.moreMenuItem}
                            onClick={() => {
                              setNameEdit(true);
                              closeMoreMenu();
                            }}
                            disabled={disabled}
                          >
                            <Icons.Rename /> <span>Rename</span>
                          </MenuItem>
                          {['subtask', 'issue', 'risk'].includes(
                            task.type ?? ''
                          ) && !template ? (
                            <MenuItem
                              className={classes.moreMenuItem}
                              onClick={() => {
                                closeMoreMenu();
                                if (setopenParentModal)
                                  setopenParentModal(true);
                                if (selectedSubTask) selectedSubTask(task);
                              }}
                              disabled={disabled}
                            >
                              <TransformIcon /> <span>Change Parent</span>
                            </MenuItem>
                          ) : (
                            <div></div>
                          )}

                          {task.type &&
                          !['decision', 'issue', 'risk', 'milestone'].includes(
                            task.type
                          ) ? (
                            <MenuItem
                              className={classes.moreMenuItem}
                              onClick={() => {
                                closeMoreMenu();
                                if (updateTaskProperty) {
                                  updateTaskProperty(
                                    task.id ?? '',
                                    'parentId',
                                    null
                                  );
                                }
                              }}
                              disabled={disabled}
                            >
                              <MoveUpIcon /> <span>Make First Level Task</span>
                            </MenuItem>
                          ) : (
                            <div></div>
                          )}
                          {task.type &&
                          !['milestone'].includes(task.type) &&
                          task.parentId === null ? (
                            <div>
                              <NestedMenuItem
                                parentMenuOpen={nestedOpen}
                                label="Change Section"
                                className={classes.moreMenuItem}
                                disabled={disabled}
                              >
                                {sectionStateList
                                  .filter(i => i.id !== task.sectionId)
                                  .map(section => {
                                    return (
                                      <MenuItem
                                        sx={{ pl: 4 }}
                                        className={classes.moreMenuItem}
                                        onClick={() => {
                                          if (updateTaskSection)
                                            updateTaskSection(task, section.id);
                                          closeMoreMenu();
                                        }}
                                        key={section.id}
                                      >
                                        <span>{section.name}</span>
                                      </MenuItem>
                                    );
                                  })}
                              </NestedMenuItem>
                            </div>
                          ) : (
                            <div></div>
                          )}
                          {(task.parentId === null ||
                            task.type === 'subtask') &&
                          !template ? (
                            <MenuItem
                              className={classes.moreMenuItem}
                              onClick={() => {
                                closeMoreMenu();
                                if (updateTaskProperty) {
                                  updateTaskProperty(
                                    task.id!,
                                    'isArchived',
                                    true
                                  );
                                }
                              }}
                              disabled={disabled}
                            >
                              <Icons.Archive /> <span>Archive Task</span>
                            </MenuItem>
                          ) : (
                            <div></div>
                          )}
                          {deleteTask && (
                            <MenuItem
                              className={classes.moreMenuItem}
                              disabled={disabled}
                              onClick={() => {
                                closeMoreMenu();
                                deleteDispatch({ task, type: 'init' });
                                dispatch(deleteTaskHistory(task.id ?? ''));
                                toast(
                                  <Undo
                                    onUndo={() => {
                                      deleteDispatch({ task, type: 'break' });
                                    }}
                                    message="Successfully deleted"
                                    taskName={task.name ?? ''}
                                  />,
                                  {
                                    onClose: () => {
                                      deleteDispatch({ task, type: 'normal' });
                                    },
                                  }
                                );
                              }}
                            >
                              <Icons.Delete2 color="#FF5630" />
                              <span style={{ color: '#FF5630' }}>Delete</span>
                            </MenuItem>
                          )}
                        </div>
                      )}
                    </Menu>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </div>
        {children && <div className={classes.TodoCardSubTask}>{children}</div>}
        {newTaskVisible && (
          <NewTask
            setnewTaskVisible={setnewTaskVisible}
            taskType={TaskType.Task}
            task={task}
            taskViewType={taskViewType}
            setInitialTaskVisible={() => {}}
            initialTaskVisible={false}
          />
        )}
      </div>
    </>
  );
};

export default TodoCard;
